import axios from 'axios'
export default() => {

 //let baseURL = 'https://adve.pro/api';
 let baseURL = 'https://adve-api.clinicaamericana.org.pe/';
    //let baseURL = '';
    if (process.env.NODE_ENV === 'development') {
        baseURL = 'http://localhost:8080/';
    }
    return axios.create({
        baseURL: baseURL,
        withCredentials: false,
        crossdomain:true,
        headers:{
            'Access-Control-Allow-Origin':'*',
            'Authorization': localStorage.getItem("hope") || ''
        }
    })
}
 